import { Grid } from "@mui/material";
import {
  ArrayInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleFormIterator,
  TextInput,
  required,
  useChoicesContext,
  useSimpleFormIteratorItem,
} from "react-admin";
import { useWatch } from "react-hook-form";
import { administrationRequests } from "api/administrationApi";
import { DoctoralStudyTypeChoices } from "utils/choices";

const InstructionLanguageSelect = ({ excludeIds }) => {
  const { allChoices, isLoading } = useChoicesContext();

  const availableChoices = (allChoices ?? []).filter(
    c => !excludeIds.includes(c.id),
  );

  return (
    <SelectInput
      source="instructionLanguageId"
      label="Език на обучение"
      choices={availableChoices}
      isLoading={isLoading}
      validate={required()}
      fullWidth
    />
  );
};

const StudyFormIteratorItem = () => {
  const { index } = useSimpleFormIteratorItem();
  const studyForms = useWatch({ name: "studyForms" });
  const studyTypeId = useWatch({ name: `studyForms.${index}.studyTypeId` });

  const takenLanguageIds =
    studyForms
      ?.filter((_, i) => i !== index)
      ?.filter(s => s?.studyTypeId === studyTypeId)
      ?.map(s => s?.instructionLanguageId)
      ?.filter(v => v != null) ?? [];

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <SelectInput
          source="studyTypeId"
          label="Форма на обучение"
          choices={DoctoralStudyTypeChoices}
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ReferenceInput
          source="instructionLanguageId"
          reference={administrationRequests.getInstructionLanguagesSelect()}
        >
          <InstructionLanguageSelect excludeIds={takenLanguageIds} />
        </ReferenceInput>
      </Grid>
      <Grid item xs={12} md={4}>
        <NumberInput
          source="annualFee"
          label="Годишна такса"
          min={0}
          step={0.01}
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

const SaveForm = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <TextInput
          label="Име на български език"
          source="nameBg"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <TextInput
          label="Име на английски език"
          source="nameEn"
          validate={required()}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <ArrayInput source="studyForms" label="Форми на обучение">
          <SimpleFormIterator inline={false} disableClear>
            <StudyFormIteratorItem />
          </SimpleFormIterator>
        </ArrayInput>
      </Grid>
    </Grid>
  );
};

export default SaveForm;
